import InputMask from 'vue-text-mask'
import { conformToMask } from 'vue-text-mask'

export default InputMask
export { InputMask, conformToMask }